module.exports = __webpack_public_path__ + "static/media/M1-2-Laydon-cod101.909d1d19.png";